<template>
<div class="chapter">
<div class="inner_page">
<p class="C841"><span class="small"><span href="#/html/52_Notes#id_14" id="page_1" title="Link target outside of Sample">TABLET</span></span></p>
<p class="C852">Up the cutbank of a creek named after stone,</p>
<p class="C854">striking stone, I came walking, my fingers</p>
<p class="C854">stained with the pulp of raspberries picked</p>
<p class="C854">from branches arched over descending snowmelt</p>
<p class="C854">beneath two clouds and blue sky no one</p>
<p class="C854">built. Napped between that extravagant</p>
<p class="C854">quilt and sunwarmed sand until the taut line</p>
<p class="C854">woke me, tugging in my palm. The trout’s</p>
<p class="C854">eye was a polished nickel poleaxed</p>
<p class="C854">by a drop of ink, though I am writing this</p>
<p class="C854">in the brown juice spit from a grasshopper’s lips,</p>
<p class="C854">instinct having made for many a miracle</p>
<p class="C854">such as this emergent mayfly shaking its wings</p>
<p class="C854">dry, to whom I whisper—Go light and soft</p>
<p class="C854">with this pittance, straight to the lord</p>
<p class="C854">whose commandments are writ in water.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Tablet.vue?3313e53b